import { AppDefaultNavigationState } from '../../../initialStateRegistration';

export const getHeader = (state: AppDefaultNavigationState) => state.header;
